import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/components/app-entry-point/app';
import './app/utils/DateUtils';
import './app/utils/Arrayutils';
import './app/utils/StringUtils';
import * as Sentry from "@sentry/angular";
import { environment } from './environments/environment';

const env = Object.entries(environment).find(([_, valor]) => valor)?.[0] || 'unknown';

Sentry.init({
  dsn: env != 'production' ? undefined : "https://6ef6ef4ce050f68ad8e45a644bdd2ef8@o469119.ingest.us.sentry.io/4511534239842304",
  // To disable sending user data, uncomment the line below. For more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/angular/configuration/options/#dataCollection
  // dataCollection: { userInfo: false }
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true,
  environment: env,
  tracesSampleRate: 1.0,
  release: env + "-development", // para hacer traza de las reseases a futuro sería interesante usarlo.
  integrations: [
    Sentry.replayIntegration()
  ],
  // debug: true,
});


bootstrapApplication(App, appConfig)
  .catch(
    (err) => console.error(err)
);
